/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import ConditionalRender from '@ion/dls/src/render/ConditionalRender';
import {dlsColor} from '@ion/dls/src/theme/theme';

type JobStepMarkerProps = {
  step: 1 | 2;
  disabled?: boolean;
}

/**
 * JobStepMarker is a display component that displays a circular step marker with a number to help
 * indicate the step of a job step.
 * 
 * @param step     - A number that notates which step you would like to display to the user.
 * @param disabled - A boolean value to indicate whether or not the step is disabled.
 */
export const JobStepMarker = ({step, disabled = false}: JobStepMarkerProps) => {
  return (
    <svg width="34" height="34" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="17" r="17" fill={dlsColor(`${disabled ? 'grey4' : 'caBlue'}`)} />
      <ConditionalRender condition={step === 1}>
        <path d="M19.2656 10.6016V22H17.0156V13.1953L14.3125 14.0547V12.2812L19.0234 10.6016H19.2656Z" fill={dlsColor('white')} />
      </ConditionalRender>
      <ConditionalRender condition={step === 2}>
        <path d="M21.5625 20.2422V22H13.7812V20.5L17.4609 16.5547C17.8307 16.1432 18.1224 15.7812 18.3359 15.4688C18.5495 15.151 18.7031 14.8672 18.7969 14.6172C18.8958 14.362 18.9453 14.1198 18.9453 13.8906C18.9453 13.5469 18.888 13.2526 18.7734 13.0078C18.6589 12.7578 18.4896 12.5651 18.2656 12.4297C18.0469 12.2943 17.776 12.2266 17.4531 12.2266C17.1094 12.2266 16.8125 12.3099 16.5625 12.4766C16.3177 12.6432 16.1302 12.875 16 13.1719C15.875 13.4688 15.8125 13.8047 15.8125 14.1797H13.5547C13.5547 13.5026 13.7161 12.8828 14.0391 12.3203C14.362 11.7526 14.8177 11.3021 15.4062 10.9688C15.9948 10.6302 16.6927 10.4609 17.5 10.4609C18.2969 10.4609 18.9688 10.5911 19.5156 10.8516C20.0677 11.1068 20.4844 11.4766 20.7656 11.9609C21.0521 12.4401 21.1953 13.013 21.1953 13.6797C21.1953 14.0547 21.1354 14.4219 21.0156 14.7812C20.8958 15.1354 20.724 15.4896 20.5 15.8438C20.2812 16.1927 20.0156 16.5469 19.7031 16.9062C19.3906 17.2656 19.0443 17.638 18.6641 18.0234L16.6875 20.2422H21.5625Z" fill={dlsColor('white')} />
      </ConditionalRender>
    </svg>
  );
};

export default memo(JobStepMarker);
